import axios from "axios";

const instance = axios.create({
  baseURL: process.env.REACT_APP_BASE_URL,
});

instance.interceptors.request.use(
  (config) => {
    return config;
  },
  (error) => {
    if (error?.response?.status === 403) {
      console.dir(error);
      error.response.statusText =
        "Your request timed out, kindly login and try again";
      if (localStorage) {
        localStorage.clear();
        window.location.replace("/login");
      }
    }
    return Promise.reject(error);
  }
);

export const postAPI = (path, data, token) => {
  const headers = {
    "x-access-token": `Bearer ${token}`,
  };
  return instance.post(path, data, { headers });
};

export const getAPI = (path, token) => {
  const headers = {
    "x-access-token": `Bearer ${token}`,
  };
  return instance.get(path, { headers });
};

export const getPDF = async (url, config) => {
  return instance.get(url, config);
};

export const putAPI = (path, data) => {
  return instance.put(path, data);
};

export const deleteAPI = (path, data) => {
  return instance.delete(path, data);
};

export const verifyAPI = async (path, token) => {
  const headers = {
    Authorization: `Bearer ${token}`,
  };

  try {
    const response = await instance.get(path, { headers });
    return response.data;
  } catch (error) {
    throw error;
    return {
      success: false,
      message: `Error occurred during API request: ${error.message}`,
    };
  }
};

export default instance;
